import { render, staticRenderFns } from "./OriginalVoucherWorkbench.vue?vue&type=template&id=2d50a01c&scoped=true"
import script from "./OriginalVoucherWorkbench.vue?vue&type=script&lang=js"
export * from "./OriginalVoucherWorkbench.vue?vue&type=script&lang=js"
import style0 from "./OriginalVoucherWorkbench.vue?vue&type=style&index=0&id=2d50a01c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50a01c",
  null
  
)

export default component.exports